import React from "react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { ApprovalProductRow } from "./approval-product-row";

const HEAD = [
  { id: "product", label: "PRODUCT", align: "left" },
  { id: "category", label: "CATEGORY", align: "left" },
  { id: "price", label: "PRICE", align: "left" },
  { id: "stock", label: "STOCK", align: "left" },
  { id: "date", label: "DATE SUBMITTED", align: "left" },
  { id: "status", label: "STATUS", align: "center" },
  { id: "actions", label: "ACTIONS", align: "center" },
];

export function ApprovalTable({ rows, onViewProduct, onEditProduct }) {
  return (
    <Table sx={{ tableLayout: "fixed" }}>
      <TableHead>
        <TableRow
          sx={{
            bgcolor: "#F8F8F8",
            "& th": {
              border: "none",
              py: 2,
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "0.06em",
              color: "#9CA3AF",
            },
          }}
        >
          {HEAD.map((col) => (
            <TableCell key={col.id} align={col.align ?? "left"}>
              {col.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.length === 0 ? (
          <TableRow>
            <TableCell colSpan={7} sx={{ border: "none", py: 10 }}>
              <p className="my-0 text-center text-[14px] font-medium text-[#9CA3AF]">
                No products match your filters.
              </p>
            </TableCell>
          </TableRow>
        ) : (
          rows.map((product) => (
            <ApprovalProductRow
              key={product.id}
              product={product}
              onViewProduct={onViewProduct}
              onEditProduct={onEditProduct}
            />
          ))
        )}
      </TableBody>
    </Table>
  );
}
